module.exports = __webpack_public_path__ + "img/arr_letters.1867db2e.svg";